import Providers from "./providers";
import RoutesProvider from "./routes";

function App() {
  return (
    <Providers>
      <RoutesProvider />
    </Providers>
  );
}

export default App;
